/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';

import { Subheading } from '../Text';

import './HealthEntryTitle.styles.scss';

const HealthEntryTitle = (props) => (
  <div className="cmp-healthentrytitle">
    <div>
      <Subheading className={props.className}>
        {props.title}
      </Subheading>
    </div>
    <div>
      {props.icon}
    </div>
  </div>
);
HealthEntryTitle.propTypes = {
  title: PropTypes.any.isRequired,
  icon: PropTypes.element,
  className: PropTypes.string,
};

export default HealthEntryTitle;
